
export class ChartDataColors
{
	static chartDataColorsList = [
		"#EEB5EB",
		"#C26DBC",
		"#C8F4F9",
		"#3CACAE",
		"#E0A030",
		"#A06204",
		"#FF2768",
		"#4E1A3D",
		"#F8AFA6",
		"#F79489",
		"#FF8300",
		"#B7AC44",
		"hsl(138, 70%, 50%)",
		"hsl(54, 70%, 50%)",

	];

	static nextColor()
	{
		const color = ChartDataColors.chartDataColorsList.shift() || "";
		ChartDataColors.chartDataColorsList.push(color);
		return color;
	}
}
